import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Coins } from "lucide-react";

/**
 * Token-saldo som vises i header. Hentes fra /wallet/me hver gang user.id endrer seg
 * (innlogging) eller når window får fokus (etter kjøp i annen fane).
 */
export default function TokenBalance() {
  const { user } = useAuth();
  const [balance, setBalance] = useState(0);

  const load = async () => {
    try {
      const r = await api.get("/wallet/me");
      setBalance(r.data.tokens || 0);
    } catch {}
  };

  useEffect(() => {
    if (!user || user === false) return;
    setBalance(user.tokens || 0);
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [user?.id]);

  if (!user || user === false) return null;

  return (
    <Link
      to="/wallet"
      className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 border border-[var(--gold)]/40 hover:border-[var(--gold)] text-[var(--gold)] font-meta text-xs transition-colors"
      data-testid="token-balance"
      data-tour="wallet"
      title="Min tokens-saldo"
    >
      <Coins className="h-3.5 w-3.5" />
      <span className="tabular-nums" data-testid="token-balance-value">{balance}</span>
    </Link>
  );
}
